<template>
  <div id="company-page" v-if="company">
    <Note collection="companies" :objectId="$route.params.id" :pinnable="false" />
    <p style="margin: 30px;">{{company.name}} Company info</p>
    <router-link :to="{ name: 'companyJobsPage', params: { id: $route.params.id } }">
        Manage Company Jobs
    </router-link>
    <br/>
    <router-link :to="{ name: 'orders', query: { filter: 'search', companyId: $route.params.id } }">
      <span style="margin-top:10px;display:block">
        Company orders
      </span>
    </router-link>
    <h1 v-if="getLastReport()" style="color:#B082F9">
      Balance: {{Math.round(getLastReport().paid * 100 - getLastReport().totalToPay * 100) / 100}}
    </h1>
    <div class="company-info" style="margin-top: 20px;" v-if="editCompany">
      <table border="1" style="margin: 0 auto">
        <tr><td>Company Name</td><td><input v-model="company.name" /></td></tr>
        <tr><td>Order Code Prefix</td><td><input v-model="company.orderCodePrefix" /></td></tr>
        <tr><td>Business Code</td><td><input v-model="company.businessCode" /></td></tr>
        <tr><td>VAT Code</td><td><input v-model="company.vatCode" /></td></tr>
        <tr><td>Email</td><td><input v-model="company.email" /></td></tr>
        <tr><td>License Type</td><td>
          <select v-model="company.licenseType">
            <option
              key="none"
              value=""
            >none</option>
            <option
              key="full"
              value="full"
            >full</option>
            <option
              key="saas"
              value="saas"
            >saas</option>
          </select>
        </td></tr>
        <tr><td>Hourly Orders Disabled</td><td>
          <select v-model="company.hourlyRateOrdersDisabled">
            <option
              key="false"
              :value="false"
            >false</option>
            <option
              key="true"
              :value="true"
            >true</option>
          </select></td></tr>
        <tr><td>No admin</td><td>
          <select v-model="company.noAdmin">
            <option
              key="false"
              :value="false"
            >false</option>
            <option
              key="true"
              :value="true"
            >true</option>
          </select></td></tr>
        <tr><td>Expenses paid by</td><td>
          <select v-model="company.expensesAccountingStrategy">
            <option
              key="client"
              value="client"
            >Client</option>
            <option
              key="company"
              value="company"
            >Company</option>
          </select></td></tr>
          <tr><td>Invoices recipient</td><td>
          <select v-model="company.invoicesRecipient">
            <option
              key="both"
              value=""
            >Client or company</option>
            <option
              key="client"
              value="client"
            >Client</option>
            <option
              key="company"
              value="company"
            >Company</option>
          </select></td></tr>
        <tr><td>Fee %</td><td><input type="number" v-model="company.feePercentage" /></td></tr>
        <tr><td>Contact bonus %</td><td><input type="number" v-model="company.contactBonusPercentage" /></td></tr>
        <tr><td>Self order bonus %</td><td><input type="number" v-model="company.orderBonusPercentage" /></td></tr>
        <tr><td>Promo bonus %</td><td><input type="number" v-model="company.promoBonusPercentage" /></td></tr>
        <tr><td>Call Out Fee</td><td><input type="number" v-model="company.callOutFee" /></td></tr>
        <tr><td>Callout bonus %</td><td><input type="number" v-model="company.bonusPercentage" /></td></tr>
        <tr v-if="company.apiKeyCount"><td>Api Keys</td><td>{{company.apiKeyCount}}</td></tr>
        <tr v-if="company.createdAt"><td>CreatedAt</td><td>{{
            company.createdAt
              ? new Date(company.createdAt.seconds * 1000).toLocaleDateString()
              : "-"
          }}</td></tr>
      </table>
      <div class="actions">
        <button @click="saveCompany">Save</button>
      </div>
    </div>
    <div class="company-info" style="margin-top: 20px;" v-else>
      <table border="1" style="margin: 0 auto">
        <tr><td>Company Name</td><td>{{company.name}}</td></tr>
        <tr><td>Order Code Prefix</td><td>{{company.orderCodePrefix}}</td></tr>
        <tr><td>Email</td><td v-html="(company.email || '').split(',').join('<br />')"></td></tr>
        <tr><td>Hourly Orders Disabled</td><td>{{company.hourlyRateOrdersDisabled}}</td></tr>
        <tr><td>No admin</td><td>{{company.noAdmin}}</td></tr>
        <tr><td>Expenses paid by</td><td>{{company.expensesAccountingStrategy || 'client'}}</td></tr>
        <tr><td>Invoices recipient</td><td>{{company.invoicesRecipient || 'client or company'}}</td></tr>
        <tr><td>Business Code</td><td>{{company.businessCode}}</td></tr>
        <tr><td>VAT Code</td><td>{{company.vatCode}}</td></tr>
        <tr><td>License Type</td><td>{{company.licenseType}}</td></tr>
        <tr v-if="!company.callOutFee"><td>Fee %</td><td>{{company.feePercentage}}</td></tr>
        <tr v-if="!company.callOutFee"><td>Contact bonus %</td><td>{{company.contactBonusPercentage}}</td></tr>
        <tr v-if="!company.callOutFee"><td>Self order bonus %</td><td>{{company.orderBonusPercentage}}</td></tr>
        <tr v-if="!company.callOutFee"><td>Promo bonus %</td><td>{{company.promoBonusPercentage}}</td></tr>
        <tr><td style="font-weight: bold;">Call out fee</td><td style="font-weight: bold;">{{company.callOutFee}}</td></tr>
        <tr v-if="company.expressCallOutFee"><td style="font-weight: bold;">Express Call out fee</td><td style="font-weight: bold;">{{company.expressCallOutFee}}</td></tr>
        <tr><td>Callout bonus%</td><td>{{company.bonusPercentage}}</td></tr>
        <tr v-if="company.apiKeyCount"><td>Api Keys</td><td>{{company.apiKeyCount}}</td></tr>
        <tr v-if="company.createdAt"><td>CreatedAt</td><td>{{
            company.createdAt
              ? new Date(company.createdAt.seconds * 1000).toLocaleDateString()
              : "-"
          }}</td></tr>
      </table>
      <div class="actions">
        <button @click="editCompany=true">Edit</button>
      </div>
    </div>
    <p style="margin: 30px;">Invoices and reports</p>
    <div class="invoices-table data-table">
      <div class="header">
        <div class="id">ID</div>
        <div>Date</div>
        <div>Service</div>
        <div>Pro</div>
        <div>Contact</div>
        <div>Total</div>
        <div>Fee</div>
        <div>URL</div>
      </div>
      <template v-for="[invoices, month] in Object.keys(invoiceGroup).sort().reverse().slice(0,4).map(k => [invoiceGroup[k], k])">
        <div
          v-for="invoice in invoices"
          v-bind:key="invoice.invoiceId"
          v-if="expandedMonth == month"
          class="row"
        >
          <div class="cell id">{{ invoice.proDocumentNumber }}<br /><router-link :to="{ name: 'orderPage', params: { id: invoice.orderId }}">{{
            invoice.orderId
          }}</router-link></div>
          <div class="cell">{{ invoice.invoiceDate }}</div>
          <div class="cell">{{ invoice.service }}</div>
          <div class="cell">{{ invoice.proName }}</div>
          <div class="cell">{{ invoice.contactId }} exp: {{invoice.expenses}}</div>
          <div class="cell">{{ invoice.total  }}|{{ invoice.totalWithDiscount  }}|{{ invoice.expenses  }}</div>
          <div class="cell">{{ invoice.fee }}</div>
          <div class="cell"><a :href="invoice.clientPdfLink">Client PDF</a></div>
        </div>
        <div class="header" v-bind:key="month">
          <div class="cell id">{{ reports && reports[month] && reports[month].reportId }}</div>
          <div @click="expandedMonth = month"><b>{{ month }}</b></div>
          <div></div>
          <div></div>
          <div></div>
          <div>{{ total(invoices, 'total') }}<br />
            <span v-if="reports && reports[month]">TOTAL: {{reports[month].total}}</span><br />
            <span v-if="reports && reports[month]">LAST TOTAL: {{reports[month].lastTotal}}</span><br />
            <span v-if="reports && reports[month]">PAID: {{reports[month].paid}}</span><br />
            <span v-if="reports && reports[month]">LAST PAID: {{reports[month].lastPaid}}</span><br />
             <span v-if="reports && reports[month]">PAYMENT AMOUNT: {{reports[month].totalToPay}}</span><br />
            <span v-if="reports && reports[month]">BONuS: {{reports[month].contactBonus}}</span><br />
          </div>
          <div>{{ total(invoices, 'fee') }}</div>
          <div class="cell actions">
            <div>
              <a v-if="reports && reports[month] && reports[month].publicLink" :href="reports[month].publicLink">Report PDF</a>
              <a v-if="reports && reports[month] && reports[month].excelLink" :href="reports[month].excelLink"> Report XLS</a>
            </div>
            <div v-if="reports && reports[month] && paymentFieldShouldBeVisible(reports[month].reportId)">
              <input v-model="paymentAmount" type="number" />
              <button v-on:click="updatePaymentAmount(reports[month].reportId)">Register payment</button>
            </div>
            <button v-if="reports && !reports[month]" v-on:click="generateCompanyReport(companyId, month)">Generate Report</button>
            <button v-if="reports && reports[month] && !reports[month].emailSent" v-on:click="sendCompanyReport(reports[month].reportId)">Send Email</button>
          </div>
        </div>
      </template>
    </div>
    <p style="margin: 30px;">Company users</p>
    <div id="members-table" class="data-table">
      <div class="header">
        <div class="id">ID</div>
        <div>First Name</div>
        <div>Last Name</div>
        <div>Phone Number</div>
        <div>Email</div>
        <div>Role</div>
      </div>
      <div
        v-for="member in members"
        v-bind:key="member.id"
        class="row"
      >
        <div class="cell id">{{ member.id }}</div>
        <div class="cell">{{ member.firstName }}</div>
        <div class="cell">{{ member.lastName }}</div>
        <div class="cell">{{ member.phoneNumber }}</div>
        <div class="cell">{{ member.email  }}</div>
        <div class="cell">{{ member.role }}</div>
      </div>
    </div>
    <p style="margin: 30px;" v-if="company.saasProsList.length">Saas Partners</p>
    <div id="members-table" class="data-table">
      <div class="header">
        <div class="id">ID</div>
        <div>First Name</div>
        <div>Last Name</div>
        <div>Phone Number</div>
        <div>Email</div>
        <div>Role</div>
      </div>
      <div
        v-for="partner in company.saasProsList"
        v-bind:key="partner"
        class="row"
      >
        <div class="cell id">{{ partner }}</div>
        <div class="cell"></div>
        <div class="cell"></div>
        <div class="cell"></div>
        <div class="cell"></div>
        <div class="cell"></div>
      </div>
    </div>
    <p style="margin: 30px;">Contacts</p>
    <div id="contacts-table" class="data-table">
      <div class="header">
        <div class="id">ID</div>
        <div>First Name</div>
        <div>Last Name</div>
        <div>Phone Number</div>
        <div>Email</div>
        <div>Company Name</div>
      </div>
      <div
        v-for="contact in getContacts()"
        v-bind:key="contact.id"
        class="row"
      >
        <div class="cell id">
          <router-link :to="{ name: 'orders', query: { filter: 'search', contactId: contact.id } }">
            {{ contact.id }}
          </router-link>
          <br/>{{contact.userId}}</div>
        <div class="cell">{{ contact.firstName }}</div>
        <div class="cell">{{ contact.lastName }}</div>
        <div class="cell">{{ contact.phoneNumber }}</div>
        <div class="cell">{{ contact.email  }}</div>
        <div class="cell">{{ contact.businessName }}</div>
      </div>
    </div>
    <p style="margin: 30px;">Invites</p>
    <div id="contacts-table" class="data-table">
      <div class="header">
        <div class="id">ID</div>
        <div>Created</div>
        <div>Expires</div>
        <div>Invite URL</div>
        <div>Email</div>
        <div>Company Name</div>
      </div>
      <div
        v-for="contact in getInvites()"
        v-bind:key="contact.id"
        class="row"
      >
        <div class="cell id">{{ contact.id }}</div>
        <div class="cell">{{ contact.createdAt ? new Date(contact.createdAt.seconds *  1000).toLocaleDateString() : '' }}</div>
        <div class="cell" :style="(contact.inviteExpiresAt.seconds * 1000) < +new Date() ? 'color:red' : '' ">{{ new Date(contact.inviteExpiresAt.seconds *  1000).toLocaleDateString() }}</div>
        <div class="cell"><a :href="contact.inviteUrl">{{contact.inviteUrl}}</a></div>
        <div class="cell">{{ contact.email  }}</div>
        <div class="cell actions"><button @click="resendInvite(contact.email)">Resend invite</button></div>
      </div>
    </div>
    <div class="actions" v-if="!company.licenseType">
      <button @click="deleteCompany">Delete company</button>
    </div>
  </div>
</template>

<style scoped lang="less">
#company-page {
  table {
    td {
      border: 1px solid #999;
      border-collapse: collapse;
      margin: 0;
      padding: 10px;
    }
  }
}

#company-page,
#company-table,  {
  input {
    padding: 10px
  }
  grid-template-columns: auto auto auto;
  .row.finished .cell {
    color: #aaa;
  }
  .actions button {
    display: inline-block;
    margin: 10px;
    padding: 10px;
    background-color: black;
    color: white;
    cursor: pointer;
  }
}

.invoices-table {
  grid-template-columns: auto auto auto auto auto auto auto auto;
  .row.disabled .cell {
    color: #aaa;
  }
  .cell input {
    padding: 10px;
  }
  .inputcell {
    padding: 0;
  }
  @media only screen and (max-width: 1000px) {
    .cell.id {
      display: none;
    }
    .header .id {
      display: none;
    }
    grid-template-columns: auto auto auto auto auto auto auto;
  }
}

#members-table, #contacts-table {
  grid-template-columns: auto auto auto auto auto auto;
  .row.disabled .cell {
    color: #aaa;
  }
  .cell input {
    padding: 10px;
  }
  .inputcell {
    padding: 0;
  }
  @media only screen and (max-width: 1000px) {
    .cell.id {
      display: none;
    }
    .header .id {
      display: none;
    }
    grid-template-columns: auto auto auto auto auto auto;
  }
}

</style>

<script>
import api from "../services/api";
import dayjs from 'dayjs';
import Note from '../components/Note.vue';

export default {
  name: "companyPage",
  data: function () {
    return {
      company: null,
      members: [],
      contacts: [],
      invoiceGroup: [],
      companyId: null,
      reports: null,
      expandedMonth: null,
      paymentAmount: 0,
      editCompany: false
    };
  },
  async created() {
    const id = this.$route.params.id;
    this.companyId = id;
    const company = await api.getCompany(id);
    company.feePercentage = Math.round(company.feePercentage * 1000000) / 10000;
    company.contactBonusPercentage = Math.round(company.contactBonusPercentage * 1000000) / 10000;
    company.promoBonusPercentage = Math.round(company.promoBonusPercentage * 1000000) / 10000;
    company.orderBonusPercentage = Math.round(company.orderBonusPercentage * 1000000) / 10000;
    company.bonusPercentage = Math.round(company.bonusPercentage * 1000000) / 10000;
    company.callOutFee = company.callOutFee / 100;
    company.expressCallOutFee = company.expressCallOutFee / 100;
    this.company = company;
    this.invoiceGroup = await api.getCompanyInvoices(id);
    // const thisMonth = dayjs().format('YYYY-MM');
    const lastMonth = dayjs().subtract(1, 'months').format('YYYY-MM');
    console.log(this.invoiceGroup);
    // if (!this.invoiceGroup[thisMonth]) {
    //   this.invoiceGroup[thisMonth] = [];
    // }
    if (!this.invoiceGroup[lastMonth]) {
      this.invoiceGroup[lastMonth] = [];
    }
    this.members = await api.getCompanyMembers(id);
    this.contacts = await api.getCompanyContacts(id);
    this.reports = await api.getCompanyReports(id);
    Object.keys(this.reports || {}).forEach(month => {
      if (!this.invoiceGroup[month]) {
        this.invoiceGroup[month] = [];
      }
    });
    document.title = this.company.name;
  },
  components: {
    Note
  },
  methods: {
    async deleteCompany() {
      if (confirm("REALLY DELETE THE COMPANY?")) {
        await api.deleteCompany(this.companyId);
        window.location = '#/companies';
      }
    },
    async saveCompany() {
      await api.saveCompany(this.companyId, {
        name: this.company.name || '',
        vatCode: this.company.vatCode || '',
        businessCode: this.company.businessCode || '',
        feePercentage: this.company.feePercentage || 0,
        licenseType: this.company.licenseType || '',
        contactBonusPercentage: this.company.contactBonusPercentage || 0,
        orderBonusPercentage: this.company.orderBonusPercentage || 0,
        promoBonusPercentage: this.company.promoBonusPercentage || 0,
        bonusPercentage: this.company.bonusPercentage || 0,
        callOutFee: Math.round(parseFloat(this.company.callOutFee) * 100),
        email: this.company.email,
        orderCodePrefix: this.company.orderCodePrefix.trim(),
        hourlyRateOrdersDisabled: this.company.hourlyRateOrdersDisabled,
        expensesAccountingStrategy: this.company.expensesAccountingStrategy,
        invoicesRecipient: this.company.invoicesRecipient,
        noAdmin: this.company.noAdmin
      });
      window.location.reload();
    },
    total(array, property) {
      let sum = 0;
      array.forEach(element => {
        sum += parseFloat(element[property])
      });
      return sum;
    },
    getContacts() {
      return this.contacts.filter(c => !c.inviteExpiresAt);
    },
    getLastReport() {
      const reports = Object.keys(this.reports || {}).sort().map(k => this.reports[k]);
      const lastReportId = this.company.lastReportId;
      for (let i = 0; i < reports.length; i++) {
        if (!lastReportId) {
          return reports[i];
        }
        if (reports[i].reportId === lastReportId) {
          if (reports[i + 1]) {
            return reports[i + 1];
          } else {
            return reports[i];
          }
        }
      }
      return false;
    },
    paymentFieldShouldBeVisible(reportId) {
      const reports = Object.keys(this.reports).sort().map(k => this.reports[k]);
      const lastReportId = this.company.lastReportId;
      for (let i = 0; i < reports.length; i++) {
        if (reportId === reports[i].reportId && !lastReportId) {
          return true;
        }
        if (reports[i].reportId === lastReportId) {
          if (reports[i + 1] && reports[i + 1].reportId === reportId) {
            return true;
          }
        }
      }
      return false;
    },
    async updatePaymentAmount(reportId) {
      if (confirm("Register payment " + this.paymentAmount / 100 + ' ?')) {
        await api.registerPayment(this.companyId, reportId, {paymentAmount: this.paymentAmount});
        window.location.reload();
      }
    },
    getInvites() {
      const invites = this.contacts.filter(c => c.inviteExpiresAt && !c.userId).map(c => ({...c, inviteUrl: 'https://business.discontract.com/' + (this.company.country === 'PL' ? 'pl-PL/' : '') + 'register?invite=' + c.inviteSecret}));
      invites.sort((i2, i1) => {
        return (i1.createdAt || i1.inviteExpiresAt).seconds - (i2.createdAt || i2.inviteExpiresAt).seconds;
      });
      const emails = {};
      this.members.forEach(member => {
        emails[member.email.toLowerCase().trim()] = true;
      });
      const filtered = invites.filter(invite => {
        const email = invite.email.toLowerCase().trim();
        if (!emails[email]) {
          emails[email] = true;
          return true;
        } else {
          return false;
        }
      });
      // console.log(emails, filtered);
      return filtered;
    },
    generateCompanyReport: async (companyId, month) => {
      if (confirm("Check if all invoices are correct")) {
        await api.generateCompanyReport(companyId, month);
        window.location.reload();
      }
    },
    async resendInvite(email) {
      if (confirm("Resend invite to " + email + " ?")) {
        await api.resendInvite(this.companyId, email);
      }
    },
    sendCompanyReport: async (reportId) => {
      if (confirm("Check if report is correct")) {
        await api.sendCompanyReport(reportId);
        window.location.reload();
      }
    }
  }
};
</script>
